import featuresConfig from '../features.config.json';

let features = null;

export function flattenConfig(item, prefix = '') {
    const result = {};

    for (const key in item) {
        if (!Object.hasOwn(item, key)) continue;

        const fullKey = prefix ? `${prefix}.${key}` : key;
        const value = item[key];

        if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
            Object.assign(result, flattenConfig(value, fullKey));
        } else {
            result[fullKey] = value;
        }
    }

    return result;
}

export function initFeatures() {
    if (features === null) {
        features = flattenConfig(featuresConfig);
    }

    window.featureEnabled = featureEnabled;
    return Promise.resolve(features);
}

export function featureEnabled(featureName) {
    if (features === null) {
        return initFeatures().then(() => features[featureName]);
    }

    return features[featureName];
}

